import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
    useEffect,
    useRef,
    useState,
} from 'react';

import {
    useClickOutside,
    useInputMask,
} from 'tools/hooks';

import DateTime from 'helpers/DateTime';

import {
    Calendar,
} from 'components/other';

import StringInput from '../StringInput';

import {
    MASK,
} from './constants';
import {
    formatValue,
    shouldChange,
} from './functions';

import styles from './DateInput.module.scss';

const DateInput: FC<IProps> = (props) => {
    const {value, inputProps, setValue} = useInputMask({
        value: props.value ?? '',
        mask: MASK,
        shouldChange,
        onChange(value) {
            const formattedValue = formatValue(value);

            props.onChangeValue?.(formattedValue);
        },
    });
    const [isOpenCalendar, setIsOpenCalendar] = useState(false);

    const containerRef = useRef<HTMLDivElement>(null);

    const onChangeCalendar = (value: Date) => {
        const formattedValue = DateTime.convertNumberToDate(value.getTime());

        setValue(formattedValue ?? '');
        setIsOpenCalendar(false);
        props.onChangeValue?.(formattedValue);
    };

    useEffect(() => {
        setValue(props.value ?? '');
    }, [props.value]);
    useClickOutside(containerRef, () => {
        setIsOpenCalendar(false);
    });

    return (
        <div
            ref={containerRef}
            className={classNames(styles.dateInput, props.className)}
        >
            <StringInput
                size={props.size}
                label={props.label}
                placeholder={props.placeholder}
                value={value}
                isDisabled={props.isDisabled}
                isError={props.isError}
                errorMessage={props.errorMessage}
                rightIcon={'calendar'}
                onClickIcon={() => setIsOpenCalendar(!isOpenCalendar)}
                {...inputProps}
            />
            {
                isOpenCalendar &&
                <Calendar
                    className={styles.calendar}
                    value={value ? new Date(value) : null}
                    onChangeValue={onChangeCalendar}
                />
            }
        </div>
    );
};

export default DateInput;
